var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconStripe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 52,
    height: 53,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H56V57H0V0ZM25.7591 21.2172C25.7591 19.6552 27.0182 19.0545 29.1036 19.0545C32.094 19.0545 35.8713 19.9756 38.8617 21.6177V12.2059C35.5959 10.8843 32.3694 10.3636 29.1036 10.3636C21.1161 10.3636 15.8042 14.6089 15.8042 21.6978C15.8042 32.7516 30.7562 30.9894 30.7562 35.7553C30.7562 37.5976 29.1823 38.1983 26.9788 38.1983C23.713 38.1983 19.5422 36.8367 16.237 34.9944V44.5262C19.8963 46.1282 23.595 46.8091 26.9788 46.8091C35.1631 46.8091 40.7897 42.6839 40.7897 35.515C40.7504 23.5801 25.7591 25.7028 25.7591 21.2172Z",
    fill: "#6772E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStripe);
export default __webpack_public_path__ + "static/media/icon-stripe.85f9e48955552b273df62ac07b08ca45.svg";
export { ForwardRef as ReactComponent };